<template>
    <div class="row mt-2">
        <div class="col-12">
            <label for="layoutpicker">{{$t('LAYOUTEDITOR.chooseLayout')}}</label>
            <multiselect v-model="currentLayout"
                         :deselect-label="$t('UI.cantRemove')"
                         track-by="id"
                         :custom-label="customLabel"
                         :max-height="600"
                         :placeholder="$t('UI.selectOne')"
                         id="layoutpicker"
                         :preserve-search="true"
                         :options="options"
                         :searchable="true"
                         :allow-empty="false"
                         @select="$emit('selected', $event)">
            </multiselect>
        </div>
    </div>
</template>

<script type="text/babel">
import Multiselect from 'vue-multiselect';

export default {
    name: 'LayoutSelection',
    data () {
        return {
            selected: this.selectedLayout || {}
        };
    },
    props: {
        selectedLayout: {
            type: Object
        },
        options: {
            type: [Array, Object]
        }
    },
    computed: {
        currentLayout: {
            get () {
                return this.selectedLayout;
            },
            set (val) {
                this.$emit('update:selectedLayout', val);
            }
        }
    },
    components: {
        Multiselect
    },
    methods: {
        customLabel ({id, title}) {
            return `${id}-${title}`;
        }
    }
};

</script>

<style lang="scss" scoped>

</style>
